<div class="my-container" [hidden]="!loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class='alert alert-danger malert-danger' *ngIf="err_validation">{{ err }}</div>
<div class='alert alert-danger malert-danger' *ngIf="err_internet_validation">{{ err_internet_text }} <span><i
      class="fas fa-sync icon"></i></span></div>


<div class="table-navigation">
  <table class='list-table table table-hover table-bordered table-condensed table-responsive table-striped'
    [ngStyle]="lang == 2 && {direction:'ltr '}">
    <tr>
      <td style='text-align:right;direction:rtl !important' class="pe_navigation_number" colspan=10>
        <button (click)='change_task(1,1,"","","")' [disabled]='new_status' *ngIf="lang == 1" class="new1">جديد</button>
        <button (click)='change_task(1,1,"","","")' [disabled]='new_status' *ngIf="lang == 2" class="new1"
          [ngClass]="{en_navigation_number:lang==2}">New</button>

        <button (click)='change_task(3,3,"","","")' *ngIf="lang == 1">جستجو</button>
        <button (click)='change_task(3,3,"","","")' *ngIf="lang == 2"
          [ngClass]="{en_navigation_number:lang==2}">Search</button>

        <button (click)="load_data(4)" [disabled]='next_status'><i class="fas fa-fast-forward"></i></button>
        <button (click)="load_data(2)" [disabled]='next_status'><i class="fas fa-forward"></i></button>
        <button (click)="load_data(3)" [disabled]='pre_status'><i class="fas fa-backward"></i></button>
        <button (click)="load_data(5)" [disabled]='pre_status'><i class="fas fa-fast-backward"></i></button>
        <div class='navigation' [ngClass]="{en_navigation_number:lang==2}"><span> {{ page_number_first }}
          </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span> {{ count_total }} </span>
        </div>
        <span class="window_title" *ngIf="lang == 1">دسته بندي</span>
        <span class="window_title" *ngIf="lang == 2">Categoty</span>
      </td>
    </tr>
  </table>
</div>
<div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
  style='overflow-x:auto;direction:rtl;' (window:resize)="change_resize()">
  <table class='table-scroll list-table table table-hover table-bordered table-condensed table-responsive table-striped'
    [ngStyle]="lang == 2 && {direction:'ltr '}">
    <tr>
      <th style='width:3% !important' *ngIf="lang==1"> رديف </th>
      <th style='width:3% !important' *ngIf="lang==2"> # </th>

      <th style='width:10% !important' *ngIf="lang==2"> Title </th>
      <th style='width:10% !important' *ngIf="lang==1"> عنوان </th>

      <th style='width:5% !important' *ngIf="lang==1"> وضعيت انتشار </th>
      <th style='width:5% !important' *ngIf="lang==2"> Status </th>

      <th style='width:5% !important' *ngIf="lang==1"> شناسه </th>
      <th style='width:5% !important' *ngIf="lang==2"> Id </th>

      <th style='width:5% !important' *ngIf="lang==1">عمليات</th>
      <th style='width:5% !important' *ngIf="lang==2">Operation</th>

    </tr>
    <tr *ngFor="let x of list_record; let i = index" id='a{{ x.shop_menu_shop_id }}'
      [ngClass]="{info:id===x.shop_menu_shop_id}" (click)="get_bg(x.shop_menu_shop_id)">
      <td>{{ i + page_number_first }}</td>
      <td>{{ x.shop_menu_shop_title | slice:0:30 }}</td>
      <td>{{ x.status_title }}</td>
      <td>{{ x.shop_menu_shop_id }}</td>
      <td>
        <span (click)='select_process(x.shop_menu_shop_id)'><i class="fas fa-desktop icon"></i></span>
        <span (click)="delete(x.shop_menu_shop_id)"><i class="far fa-trash-alt icon" style='margin:0px 4px;'></i></span>
      </td>
    </tr>
  </table>
</div>


<ngx-smart-modal #myModal identifier="myModal" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
  <form #form_myModal="ngForm">
    <div style='text-align:center;padding:12px !important' *ngIf="lang == 1 ">
      <span *ngIf="task_type==1">جديد</span>
      <span *ngIf="task_type==2">ويرايش</span>
    </div>
    <div style='text-align:center;padding:12px !important' *ngIf="lang == 2 ">
      <span *ngIf="task_type==1">New</span>
      <span *ngIf="task_type==2">Update</span>
    </div>
    <div class="row">
      <div class='col-md-6 col-lg-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'>
          <span *ngIf="lang == 1"> عنوان : </span>
          <span *ngIf="lang == 2"> Title : </span>
          <input class='wh-input' name='title' [(ngModel)]='title' pattern="[{{ pattern_title_with_persian }}]{1,}"
            autocomplete="off" required>
        </label>
      </div>

      <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'>
          <span> متن قرارداد : </span>
          <textarea class='wh-input' name='contract' [(ngModel)]='contract' [innerHTML]="contract" autocomplete="off"
            style="height:300px"></textarea>
        </label>
      </div>

      <div class='col-md-6 col-lg-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="status_id" class='wh-label'>
          <span *ngIf="lang == 1"> وضعيت نمايش : </span>
          <span *ngIf="lang == 2"> Status : </span>
          <select class='wh-input' name='status_id' [(ngModel)]='status_id' pattern="[0-9]{1,}" required>
            <option value=""></option>
            <option *ngFor='let x of list_status' value="{{ x.status_id }}">
              <span>{{ x.status_title }}</span>
            </option>
          </select>
        </label>
      </div>
    </div>
    <div class="row">
      <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center' *ngIf="lang == 1 ">
        <button mat-raised-button class="btn" *ngIf='task_type == 1 ' (click)="insert()"
          [disabled]="!form_myModal.valid">ارسال و ذخيره</button>
        <button mat-raised-button class="btn" *ngIf='task_type == 2' (click)="update()"
          [disabled]="!form_myModal.valid">ويرايش</button>
      </div>
      <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center' *ngIf="lang == 2 ">
        <button mat-raised-button class="btn" *ngIf='task_type == 1 ' (click)="insert()"
          [disabled]="!form_myModal.valid"> Save </button>
        <button mat-raised-button class="btn" *ngIf='task_type == 2' (click)="update()"
          [disabled]="!form_myModal.valid">Update</button>
      </div>
    </div>
  </form>
</ngx-smart-modal>

<ngx-smart-modal #myModalSearch identifier="myModal" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
  <form #form_myModalSearch="ngForm">
    <div style='text-align:center;padding:12px !important' *ngIf="lang == 1 ">جستجو</div>
    <div style='text-align:center;padding:12px !important' *ngIf="lang == 2 ">Search</div>
    <div class="row">
      <div class='col-md-6 col-lg-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'>
          <span *ngIf="lang == 1"> عنوان : </span>
          <span *ngIf="lang == 2"> Title : </span>
          <input class='wh-input' name='title_search' [(ngModel)]='title_search'
            pattern="[{{ pattern_title_with_persian }}]{1,}" autocomplete="off"></label>
      </div>
    </div>
    <div class="row">
      <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center;font-family:irsans'
        *ngIf="lang == 1 ">
        <button mat-raised-button class="btn" (click)="load_data(6)"
          [disabled]="!form_myModalSearch.form.valid">جستجو</button>
      </div>
      <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center;font-family:en'
        *ngIf="lang == 2 ">
        <button mat-raised-button class="btn" (click)="load_data(6)">Search</button>
      </div>
    </div>
  </form>
</ngx-smart-modal>